export * from './DadosGerais'